export default __webpack_public_path__ + "static/media/licence.bc96dad7.svg";